import { useTheme } from '@emotion/react';

import { useMedia } from '@packlink/utils';

/**
 *
 * In tests by default the hook will return true, so the component will be rendered in mobile view.
 * Use `mockTabletMediaQuery()` from `@mocks/window/matchMedia` to mock the tablet media query and force the hook to return false.
 *
 */
export function useIsMobile(): boolean {
    const theme = useTheme();
    const isDesktop = useMedia(theme.mediaQuery('tablet'));

    return !isDesktop;
}
